import { LocationConfigurationContext } from "@/providers/LocationConfigurationProvider";
import { useContext } from "react";

function Logo() {
  const locationConfiguration = useContext(LocationConfigurationContext);
  const LogoComponent = locationConfiguration?.logo;

  if (!LogoComponent) {
    return null;
  }

  return (
    <div className="max-md:max-w-[25vh] md:max-h-[200px] md:aspect-square py-3 mx-auto flex items-center justify-center [&_svg]:w-full [&_svg]:h-full">
      {LogoComponent}
    </div>
  );
}

export { Logo };
